import {useTranslation} from "react-i18next";
import icon_phone from '../assets/icon/ic_phone_2.svg';
import {useState} from "react";
import ContactDialog from "./ContactDialog";

function AskForDetail(props) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    return (
        <>
            <div className="bg-primary text-white text-4xl font-bold py-4
                        flex flex-row place-content-center items-center gap-4">
                <div className="max-md:text-base text-4xl">{t("ask_for_detail_title")}</div>
                <button onClick={() => setOpen(true)}
                        className="rounded-sm text-primary max-md:text-base text-2xl bg-white py-3 px-6 flex flex-row gap-2 items-center">
                    <img src={icon_phone} alt="icon_phone" className="h-6"/>
                    {t("ask_for_detail_button")}
                </button>
            </div>
            <ContactDialog open={open} onClose={() => setOpen(false)}/>
        </>
    )
}

export default AskForDetail;